export function showFinderAjax() {

  let __sf_request_id = 0;
  const qs  = (s, r=document) => r.querySelector(s);
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));

  function makeScrollRevealer({ baseMs = 100, cap = 6 } = {}) {
    if (!('IntersectionObserver' in window)) {
      return {
        observeAll(root=document) {
          root.querySelectorAll('.reveal-on-scroll').forEach(el => el.classList.add('is-visible'));
        }
      };
    }

    const observer = new IntersectionObserver((entries) => {

      const batch = entries.filter(e => e.isIntersecting);
      if (!batch.length) return;

      batch.sort((a, b) => {
        const pos = a.target.compareDocumentPosition(b.target);
        if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
        if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
        return 0;
      });


      batch.forEach((entry, idx) => {
        const el = entry.target;
        const step = Math.min(idx, cap); 
        const ms   = step * baseMs;

        el.style.setProperty('--reveal-delay', `${ms}ms`);
        el.style.setProperty('animation-delay', `${ms}ms`);

        el.classList.add('is-visible');
        observer.unobserve(el);
      });
    }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 });

    return {
      observeAll(root=document) {
        root.querySelectorAll('.reveal-on-scroll:not(.is-visible)').forEach(el => observer.observe(el));
      }
    };
  }

  function sequenceChildren(container) {
    Array.from(container.children).forEach(el => el.classList.add('reveal-on-scroll'));
  }


  function escapeHtml(s){ return (s||'').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }

  function hydrateFromUrl(form){
    const params = new URLSearchParams(window.location.search);

    const setMulti = (name, values) => {
      const sel = form.querySelector(`select[name="${name}[]"], select[name="${name}"]`);
      if (!sel) return;
      const set = new Set(values.map(String));
      Array.from(sel.options).forEach(o => (o.selected = set.has(o.value)));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const setInput = (name, val) => {
      const el = form.querySelector(`[name="${name}"]`);
      if (el) el.value = val;
    };

    const extractIds = (vals) =>
      vals.flatMap(v => String(v).split(','))
          .map(s => s.trim()).filter(Boolean)
          .map(s => s.split('-')[0]).filter(x => /^\d+$/.test(x));

    if (params.has('q')) setInput('pattern', params.get('q'));
    const venueIds = extractIds(params.getAll('venueId')); if (venueIds.length) setMulti('venues', venueIds);
    const typeIds  = extractIds(params.getAll('typeId'));  if (typeIds.length)  setMulti('types',  typeIds);

    const venuesNew = params.getAll('venues').flatMap(v => v.split(',').map(s=>s.trim())).filter(Boolean);
    if (venuesNew.length) setMulti('venues', venuesNew);
    const typesNew  = params.getAll('types').flatMap(v => v.split(',').map(s=>s.trim())).filter(Boolean);
    if (typesNew.length) setMulti('types',  typesNew);

    const truthy = v => ['1','true','yes','y','on',''].includes(String(v).toLowerCase());

    // Handle timing multi-select
    const timingMap = {
      'run': 'isCurrentlyRunning',
      'soon': 'isComingSoon',
      'close': 'isClosingSoon'
    };
    const timingValues = [];
    for (const [param, value] of Object.entries(timingMap)) {
      if (params.has(param) && truthy(params.get(param))) {
        timingValues.push(value);
      }
    }
    if (timingValues.length) setMulti('timing', timingValues);

    // Handle offers multi-select
    const offersMap = {
      'tdfMembership': 'isTDFMembership',
      'm': 'isTDFMembership',
      'oob': 'isOffOffAndBeyond',
      'tkts': 'isTKTSFrequently'
    };
    const offersValues = [];
    for (const [param, value] of Object.entries(offersMap)) {
      if (params.has(param) && truthy(params.get(param))) {
        if (!offersValues.includes(value)) {
          offersValues.push(value);
        }
      }
    }
    if (offersValues.length) setMulti('offers', offersValues);
  }

  function serializeForm(form){
    const fd = new FormData(form);
    const obj = {};

    fd.forEach((v,k)=>{
      if (k.endsWith('[]')) {
        const key = k.slice(0, -2);
        (obj[key] ||= []).push(v);
      } else {
        if (obj[k] !== undefined) {
          if (!Array.isArray(obj[k])) obj[k] = [obj[k]];
          obj[k].push(v);
        } else {
          obj[k] = v;
        }
      }
    });

    obj.venues = obj.venues || qsa('[data-sf-venues] option:checked', form).map(o=>o.value);
    obj.types  = obj.types  || qsa('[data-sf-types]  option:checked', form).map(o=>o.value);

    const offersSel = Array.isArray(obj.offers) ? obj.offers : (obj.offers ? [obj.offers] : []);
    const timingSel = Array.isArray(obj.timing) ? obj.timing : (obj.timing ? [obj.timing] : []);
    ['isTDFMembership','isOffOffAndBeyond','isTKTSFrequently'].forEach(k => { obj[k] = offersSel.includes(k) ? 1 : 0; });
    ['isCurrentlyRunning','isComingSoon','isClosingSoon'].forEach(k => { obj[k] = timingSel.includes(k) ? 1 : 0; });

    const pageEl = qs('[data-sf-page]', form);
    const psEl   = qs('[data-sf-pagesize]', form);
    obj.page     = parseInt(pageEl?.value || '1', 10) || 1;
    obj.pageSize = parseInt(psEl?.value || '24', 10) || 24;

    obj.pattern = obj.pattern || '';

    return obj;
  }

  async function fetchShows(payload){
    const fd = new FormData();
    fd.append('action', 'tdf_showfinder_query');
    fd.append('nonce',  TDF_SF_AJAX?.nonce || '');
    fd.append('pattern', payload.pattern || '');
    fd.append('page',     String(payload.page || 1));
    fd.append('pageSize', String(payload.pageSize || 24));

    (payload.venues || []).forEach(v => fd.append('venues[]', v));
    (payload.types  || []).forEach(v => fd.append('types[]', v));
    (payload.showIds || []).forEach(v => fd.append('showIds[]', v));

    fd.append('isTDFMembership',    payload.isTDFMembership ? '1' : '0');
    fd.append('isOffOffAndBeyond',  payload.isOffOffAndBeyond ? '1' : '0');
    fd.append('isTKTSFrequently',   payload.isTKTSFrequently ? '1' : '0');
    fd.append('isCurrentlyRunning', payload.isCurrentlyRunning ? '1' : '0');
    fd.append('isComingSoon',       payload.isComingSoon ? '1' : '0');
    fd.append('isClosingSoon',      payload.isClosingSoon ? '1' : '0');

    const res = await fetch(TDF_SF_AJAX.url, { method: 'POST', body: fd });
    if (!res.ok) throw new Error(`Network ${res.status}`);
    const json = await res.json();
    if (!json?.success) throw new Error(json?.data?.message || 'Request failed');
    return json.data;
  }

  function formatDateISO(d){
    if (!d) return '';
    const dt = new Date(d);
    if (isNaN(dt)) return '';
    return dt.toLocaleDateString(undefined, { month:'short', day:'numeric', year:'numeric' });
  }

  function buildDateLine(show){
    const previewDate = show.PreviewStart || null;
    const openingDate = show.OpeningDate || null;
    const endRaw   = show.ClosingDate || null;

    // If there's no closing date, it's an open run
    if (!endRaw) {
      // Prefer preview date, fall back to opening date
      const displayDate = previewDate || openingDate;
      return displayDate ? `${formatDateISO(displayDate)} — OPEN RUN` : `OPEN RUN`;
    }

    // Has both start and end dates - prefer preview date if available
    const startRaw = previewDate || openingDate;
    if (startRaw && endRaw) return `${formatDateISO(startRaw)} — ${formatDateISO(endRaw)}`;

    // Only has end date
    if (endRaw) return `Until ${formatDateISO(endRaw)}`;

    return '';
  }

function cardHTML(show, order = null, inPullout = false){
      const slug = (show.Title || '').toLowerCase().trim()
      .replace(/[^a-z0-9\s-]/g,'').replace(/\s+/g,'-');
    const href = `/shows/${show.ShowId}/${slug}/`;
    const img  = show.ShowImage ? `https://media3.tdf.org/s/${show.ShowId}/${show.ShowImage}` : '';

    const tName  = (show.TheaterName || '').trim();
    const dateLine = buildDateLine(show);
    const dateHtml = dateLine ? `<div class="show-card__dates">${escapeHtml(dateLine)}</div>` : '';

    const orderStyle = order !== null ? ` style="order: ${order};"` : '';
    const revealClass = inPullout ? '' : ' reveal-on-scroll';

    return `
      <div class="show-card${revealClass}"${orderStyle}>
        <a href="${href}" class="show-card__link" aria-label="${escapeHtml(show.Title||'')}">
          ${img ? `<div class="show-card__image"><img src="${img}" width="100%" height="300" alt="${escapeHtml(show.Title||'')}"></div>` : ''}
          <div class="show-card__meta">
            <h3 class="show-card__title is-style-heading-5">${escapeHtml(show.Title||'')}</h3>
            ${dateHtml}
            ${tName ? `<div class="show-card__venue">${escapeHtml(tName)}</div>` : ''}

            <div class="wp-block-buttons is-style-margin-top-auto">
              <div class="wp-block-button">
                <span class="wp-block-button__link">View Show</span>
              </div>
            </div>
          </div>
        </a>
      </div>
    `;
  }

  function pulloutHTML(pullout, shows, order){
    if (!pullout || !shows || shows.length === 0) return '';

    const title = escapeHtml(pullout.title || '');
    const colour = pullout.colour || 'primary-colour';
    const colourClass = `has-${colour}-background-color`;

    const showCards = shows.map(show => cardHTML(show, null, true)).join('');

    return `
      <div class="show-finder-pullout reveal-on-scroll farlo-ui-colour-block ${colourClass}" style="order: ${order};">
        ${title ? `<h3 class="show-finder-pullout__title is-style-heading-3">${title}</h3>` : ''}
        <div class="show-finder-pullout__shows js-pullout-slider">
          ${showCards}
        </div>
      </div>
    `;
  }

  function initPulloutSliders(container) {
    if (typeof window.Flickity !== 'function') {
      // console.warn('[SF] Flickity not available');
      return;
    }

    const sliders = container.querySelectorAll('.js-pullout-slider');
    sliders.forEach(slider => {
      // Don't re-initialize if already a Flickity instance
      if (window.Flickity.data(slider)) return;

      const flkty = new window.Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: false,
        prevNextButtons: true,
        freeScroll: true,
        groupCells: true,
        draggable: true
      });

      // Move navigation buttons into a wrapper for styling
      const prevBtn = slider.querySelector('.flickity-button.previous');
      const nextBtn = slider.querySelector('.flickity-button.next');

      if (prevBtn && nextBtn) {
        const wrapper = document.createElement('div');
        wrapper.className = 'show-finder-pullout__nav';
        slider.appendChild(wrapper);
        wrapper.appendChild(prevBtn);
        wrapper.appendChild(nextBtn);
      }

      // Equalize card heights
      const syncCardHeights = () => {
        const cards = slider.querySelectorAll('.show-card');
        if (!cards.length) return;

        // Reset heights first to get natural heights
        cards.forEach(card => { card.style.height = ''; });

        // Find the tallest card
        let maxHeight = 0;
        cards.forEach(card => {
          const height = card.offsetHeight;
          if (height > maxHeight) maxHeight = height;
        });

        // Apply max height to all cards
        if (maxHeight > 0) {
          cards.forEach(card => { card.style.height = `${maxHeight}px`; });
        }

        // Ensure Flickity recalculates after height changes
        flkty.resize();
        flkty.reposition();
      };

      // Helper for double RAF (ensures layout is complete)
      const raf = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));

      // Initial equalization after layout
      raf(syncCardHeights);

      // Re-equalize on various events
      flkty.on('ready', () => raf(syncCardHeights));
      flkty.on('resize', () => raf(syncCardHeights));

      // Handle window resize with debouncing
      let resizeTimeout;
      const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          syncCardHeights();
        }, 150);
      };
      window.addEventListener('resize', handleResize);

      // Clean up on destroy
      flkty.on('destroy', () => {
        window.removeEventListener('resize', handleResize);
        slider.querySelectorAll('.show-card').forEach(card => {
          card.style.height = '';
        });
      });
    });
  }

  function updateCount(el, total){
    if (!el) return;
    el.innerHTML = `<strong>${total}</strong> Listings`;
    el.style.display = '';
  }

  function pushUrl(form, payload){
    const params = new URLSearchParams(window.location.search);

    const setOrDelete = (key, value) => {
      if (value === undefined || value === null || value === '' || value === false) {
        params.delete(key);
      } else {
        params.set(key, value);
      }
    };

    ['q','venueId','typeId','tdfMembership','m','oob','tkts','run','soon','close'].forEach(k => params.delete(k));

    // Text + multi-selects
    setOrDelete('q', payload.pattern || '');
    if (payload.venues?.length)  setOrDelete('venueId', payload.venues.join(','));
    if (payload.types?.length)   setOrDelete('typeId',  payload.types.join(','));

    // Booleans — use tdfMembership=true for TDF (and drop legacy "m")
    if (payload.isTDFMembership) setOrDelete('tdfMembership', 'true');
    else                         setOrDelete('tdfMembership', '');

    if (payload.isOffOffAndBeyond)  setOrDelete('oob',   '1'); else setOrDelete('oob',   '');
    if (payload.isTKTSFrequently)   setOrDelete('tkts',  '1'); else setOrDelete('tkts',  '');
    if (payload.isCurrentlyRunning) setOrDelete('run',   '1'); else setOrDelete('run',   '');
    if (payload.isComingSoon)       setOrDelete('soon',  '1'); else setOrDelete('soon',  '');
    if (payload.isClosingSoon)      setOrDelete('close', '1'); else setOrDelete('close', '');

    // Write the merged params back without touching the path or hash
    const qs = params.toString();
    history.replaceState(null, '', qs ? `${location.pathname}?${qs}` : location.pathname);
  }


  const roots = document.querySelectorAll('.farlo-ui-show-finder, .farlo-ui-show-finder');
  //console.log('[SF] blocks found:', roots.length);
  roots.forEach(bindBlock);

  function bindBlock(root){
    //console.log('[SF] binding root:', root);

    const form          = root.querySelector('[data-sf-form]');
    const resultsWrap   = root.querySelector('[data-sf-results]');
    const countEl       = root.querySelector('[data-sf-count]');
    const pageEl        = root.querySelector('[data-sf-page]');
    const psEl          = root.querySelector('[data-sf-pagesize]');
    const lmWrap        = root.querySelector('[data-sf-loadmore-wrap]');
    const lmBtn         = root.querySelector('[data-sf-loadmore]');
    const clearBtn      = root.querySelector('[data-sf-clear]');
    const clearWrap     = root.querySelector('[data-sf-clear-wrap]');
    const filtersEl     = root.querySelector('[data-sf-filters]');
    const filtersSpacer = root.querySelector('[data-sf-filters-spacer]');
    const filtersSentinel = root.querySelector('[data-sf-filters-sentinel]');

    // Get pullouts data from root element
    let pullouts = [];
    try {
      const pulloutsData = root.dataset.pullouts;
      if (pulloutsData) {
        pullouts = JSON.parse(pulloutsData);
      }
    } catch (e) {
      //console.warn('[SF] Failed to parse pullouts data:', e);
    }

    if (!form || !resultsWrap || !pageEl) {
      //console.warn('[SF] Missing required hooks on this block. Skipping.');
      return;
    }

    const STAGGER_MS  = parseInt(resultsWrap?.dataset?.stagger || '100', 10);
    const STAGGER_CAP = parseInt(resultsWrap?.dataset?.staggerCap || '6', 10);
    const revealer    = makeScrollRevealer({ baseMs: STAGGER_MS, cap: STAGGER_CAP });

    function debounce(fn, wait){ let t; return (...args)=>{ clearTimeout(t); t=setTimeout(()=>fn(...args), wait); }; }
    const debouncedSearch = debounce(()=>runSearch(true), 300);

    // Sticky filters setup (desktop only, 980px+)
    function setupStickyFilters() {
      if (!filtersEl || !filtersSpacer || !filtersSentinel) return;

      // Only enable on desktop (matches the @media breakpoint)
      const isDesktop = () => window.innerWidth > 980;

      if (!isDesktop()) return;

      // Get the header height offset
      const getHeaderOffset = () => {
        const headerHeight = getComputedStyle(document.documentElement)
          .getPropertyValue('--header-height')
          .trim();
        return headerHeight ? parseInt(headerHeight) : 60;
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (!isDesktop()) return;

            // When sentinel goes out of view at the top, make filters sticky
            if (!entry.isIntersecting) {
              filtersSpacer.classList.add('is-active');
              filtersEl.classList.add('is-stuck');
              document.body.classList.add('show-finder-filters-stuck');
            } else {
              // When sentinel comes back into view, remove sticky
              filtersSpacer.classList.remove('is-active');
              filtersEl.classList.remove('is-stuck');
              document.body.classList.remove('show-finder-filters-stuck');
            }
          });
        },
        {
          threshold: 0,
          rootMargin: `-${getHeaderOffset()}px 0px 0px 0px`
        }
      );

      observer.observe(filtersSentinel);

      // Clean up on window resize if switching to mobile
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (!isDesktop()) {
            filtersSpacer.style.height = '';
            filtersSpacer.classList.remove('is-active');
            filtersEl.classList.remove('is-stuck');
            document.body.classList.remove('show-finder-filters-stuck');
          }
        }, 100);
      });
    }

    setupStickyFilters();

    function updateClearButtonVisibility(){
      if (!clearWrap) return;

      const patternEl = form.querySelector('input[name="pattern"]');
      const hasPattern = patternEl && patternEl.value.trim() !== '';

      const hasSelectedOptions = Array.from(form.querySelectorAll('select[multiple] option:checked')).length > 0;

      const shouldShow = hasPattern || hasSelectedOptions;
      clearWrap.style.display = shouldShow ? '' : 'none';
    }

    form.addEventListener('change', (e)=>{
      if (e.target.matches('select, input[type="checkbox"], input[type="radio"]')) {
        updateClearButtonVisibility();
        debouncedSearch();
      }
    });

    const kw = form.querySelector('input[name="pattern"]');
    if (kw) {
      kw.addEventListener('input', ()=>{
        updateClearButtonVisibility();
        debouncedSearch();
      });
      kw.addEventListener('change', ()=>{
        updateClearButtonVisibility();
        debouncedSearch();
      });
    }

    form.addEventListener('submit', (e)=>{ e.preventDefault(); runSearch(true); });

    async function runSearch(reset=true){
      const __req = ++__sf_request_id;

      const payload = serializeForm(form);
      if (reset) {
        payload.page = 1;
        pageEl.value = '1';
      }
      pushUrl(form, payload);
      root.classList.add('is-loading');
      resultsWrap.setAttribute('aria-busy', 'true');
      try {
        const data = await fetchShows(payload);

        if (__req !== __sf_request_id) { return; }

        const totalKeys = ['total','Total','count','Count','totalRecords','TotalRecords','recordsTotal'];
        let total = 0;
        for (const k of totalKeys) {
          const v = data?.[k];
          if (v !== undefined && v !== null && !isNaN(Number(v))) { total = Number(v); break; }
        }
        if (!total) {
          const page = parseInt(pageEl?.value || '1', 10) || 1;
          const ps   = parseInt(psEl?.value || '24', 10) || 24;
          total = (page-1)*ps + ((data.shows||[]).length);
        }
        // Check if this is Google Analytics fallback data
        const isFallback = data.isFallback === true;
        const fallbackMessage = data.fallbackMessage || 'Sorry! We couldn\'t find an exact match, but here are some popular shows to check out.';

        // Update count - show 0 if fallback, otherwise show total
        updateCount(countEl, isFallback ? 0 : total);

        if (!Array.isArray(data.shows) || data.shows.length === 0) {
          updateCount(countEl, 0);

          // No results - display empty state
          resultsWrap.innerHTML = `<div class="finder-results-widget-view" style="grid-column: 1 / -1; width: 100%;"><h3 class="is-style-heading-3">Sorry! We couldn't find an exact match.</h3></div>`;

          lmWrap && (lmWrap.style.display = 'none');
          root.classList.remove('is-loading');
          resultsWrap.removeAttribute('aria-busy');
          return;
        }

        // Check if filters are active
        const hasFilters = payload.pattern ||
                          (payload.venues && payload.venues.length > 0) ||
                          (payload.types && payload.types.length > 0) ||
                          payload.isTDFMembership || payload.isOffOffAndBeyond ||
                          payload.isTKTSFrequently || payload.isCurrentlyRunning ||
                          payload.isComingSoon || payload.isClosingSoon;

        // Build HTML with pullouts at the end, using CSS order for positioning
        let html = '';
        if (!hasFilters && pullouts.length > 0 && reset && payload.page === 1) {
          // Fetch all pullout shows by their IDs
          const allPulloutShowIds = [];
          pullouts.forEach(pullout => {
            const showIds = Array.isArray(pullout.shows) ? pullout.shows : [pullout.shows];
            allPulloutShowIds.push(...showIds);
          });

          // Fetch pullout shows separately
          let pulloutShowsData = [];
          if (allPulloutShowIds.length > 0) {
            try {
              const pulloutPayload = {
                showIds: allPulloutShowIds,
                page: 1,
                pageSize: allPulloutShowIds.length
              };
              const pulloutResult = await fetchShows(pulloutPayload);
              pulloutShowsData = pulloutResult.shows || [];
            } catch (e) {
              //console.warn('[SF] Failed to fetch pullout shows:', e);
            }
          }

          // Create a map of pullout show IDs to show data
          const pulloutShowMap = {};
          pulloutShowsData.forEach(show => {
            pulloutShowMap[show.ShowId] = show;
          });

          // Render shows with EVEN order values (2, 4, 6, 8...)
          const showCards = (data.shows || []).map((show, idx) => {
            const orderValue = (idx + 1) * 2;
            return cardHTML(show, orderValue);
          }).join('');

          // Render pullouts with ODD order values based on their position
          // If pullout order = 3, it should get order value 5 (2*3-1) to appear between cards 2 and 3
          const pulloutCards = pullouts.map(pullout => {
            // Convert shows to array if it's not already (handles both single values and arrays)
            const showIds = Array.isArray(pullout.shows) ? pullout.shows : [pullout.shows];

            const pulloutShows = showIds
              .map(showId => {
                // Convert to number for lookup
                const id = parseInt(showId, 10);
                return pulloutShowMap[id];
              })
              .filter(Boolean);

            if (pulloutShows.length === 0) return '';

            // Convert position to odd order value
            // Position 3 becomes order 5 (2*3-1), appearing between cards at order 4 and 6
            const orderValue = (pullout.order * 2) - 1;

            return pulloutHTML(pullout, pulloutShows, orderValue);
          }).filter(Boolean).join('');

          html = showCards + pulloutCards;
        } else if (!hasFilters && !reset) {
          // Load More: continue even order values from existing cards
          const existingCards = resultsWrap.querySelectorAll('.show-card[style*="order"]');
          let maxOrder = 0;
          existingCards.forEach(card => {
            const orderMatch = card.getAttribute('style')?.match(/order:\s*(\d+)/);
            if (orderMatch) {
              const orderVal = parseInt(orderMatch[1], 10);
              if (orderVal > maxOrder && orderVal % 2 === 0) { // Only count even orders (regular cards)
                maxOrder = orderVal;
              }
            }
          });

          // Start new cards from next even number
          const startOrder = maxOrder + 2;
          html = (data.shows||[]).map((show, idx) => {
            const orderValue = startOrder + (idx * 2);
            return cardHTML(show, orderValue);
          }).join('');
        } else {
          // Filters active: don't use order values
          html = (data.shows||[]).map(show => cardHTML(show)).join('');
        }

        if (reset) {
          // If this is fallback data, prepend the message
          if (isFallback && fallbackMessage) {
            const messageHtml = `
              <div class="finder-results-widget-view" style="grid-column: 1 / -1; width: 100%;">
                <h3 class="is-style-heading-3">${escapeHtml(fallbackMessage)}</h3>
              </div>
            `;
            resultsWrap.innerHTML = messageHtml + html;
          } else {
            resultsWrap.innerHTML = html || `<div class="finder-result col-d-100"><div class="title-25 black">No results</div></div>`;
          }
          sequenceChildren(resultsWrap);
        } else {
          resultsWrap.insertAdjacentHTML('beforeend', html);
          sequenceChildren(resultsWrap);
        }

        // Initialize Flickity sliders for pullouts
        if (!hasFilters && pullouts.length > 0 && reset && payload.page === 1) {
          initPulloutSliders(resultsWrap);
        }

        revealer.observeAll(resultsWrap);

        if (data.nextPage) {
          lmWrap && (lmWrap.style.display = '');
          lmBtn  && (lmBtn.dataset.nextPage = data.nextPage);
        } else {
          lmWrap && (lmWrap.style.display = 'none');
          lmBtn  && (lmBtn.dataset.nextPage = '');
        }
      } catch (e) {
        //console.error('[SF] error', e);
        const note = document.createElement('div');
        note.className = 'sf-inline-error';
        note.textContent = 'Sorry—something went wrong loading results. Please try again.';
        resultsWrap.prepend(note);
        lmWrap && (lmWrap.style.display = 'none');
      } finally {
        root.classList.remove('is-loading');
        resultsWrap.removeAttribute('aria-busy');
      }
    }

    form.addEventListener('submit', (e)=>{ e.preventDefault(); runSearch(true); });

    lmBtn?.addEventListener('click', (e)=>{
      e.preventDefault();
      const next = parseInt(lmBtn.dataset.nextPage || '0', 10);
      if (!next) return;
      pageEl.value = String(next);
      runSearch(false);
    });

    clearBtn?.addEventListener('click', ()=>{
      form.reset();
      root.querySelectorAll('select[multiple]').forEach(sel=>{
        sel.querySelectorAll('option').forEach(o=>o.selected=false);
        // Trigger change event to update custom multiSelect UI
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      updateClearButtonVisibility();
      runSearch(true);
    });

    hydrateFromUrl(form);
    updateClearButtonVisibility();
    runSearch(true);
  }
}
